module.exports = __webpack_public_path__ + "img/vertical_3_3_7016.b2643946.png";